import { render, staticRenderFns } from "./DeleteWechatAdvert.vue?vue&type=template&id=3ce59e8e"
import script from "./DeleteWechatAdvert.vue?vue&type=script&lang=js"
export * from "./DeleteWechatAdvert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports